import { Link } from "react-router-dom"

function SidebarItem({ icon, label, isActive = false, link, onClick }) {
    return (
      <Link to={link} className={`sidebar-item ${isActive ? 'active' : ''}`} onClick={onClick}>
        <span className="me-2">{icon}</span>
        <span>{label}</span>
      </Link>
    )
  }
  
  export default SidebarItem